<h3 class="soft-text-l ml-2 mr-2">Lagerartikel auswählen</h3>
<p class="soft-text color-light ml-2 mr-2">Bitte wählen Sie den gewünschten Lagerartikel durch tippen aus.</p>

<div class="c center pt-2 pb-2 min-h" *ngIf="loading$ | async; else itemsTemplate">
    <soft-loading-spinner class="spin"></soft-loading-spinner>
</div>

<ng-template #itemsTemplate>
    <div class="c column ml-2 mr-2 border-box mt-2">
        <div class="c column no-wrap mb-3 mt-3 soft-scroll-vertical border-box" style="overflow: auto; max-height: 45vh;" *ngIf="lagerartikel$ | async as lagerartikel">
            <div *ngFor="let lagerartikel of lagerartikel; let last = last" class="soft-text c column py-2" [ngClass]="last ? '' : 'border-b-separator'" style="width: 100%; padding: 0.5rem 0;" (click)="select(lagerartikel)">
                <span class="soft-text-s color-light">{{ lagerartikel?.artikelnummer }}</span>
                <span style="font-weight: 600;">{{ lagerartikel?.bezeichnung }}</span>
            </div>
        </div>
    </div>
</ng-template>

<button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
